import React from "react";
import { Modal } from "reactstrap";
import { RouteComponentProps, withRouter } from "react-router-dom";
import NewPlansContainer from "./containers/NewPlansContainer";

interface Props extends RouteComponentProps {}

const NewPlansView = ({ history }: Props) => {
  const toggle = () => {
    history.goBack();
  };

  return (
    <Modal isOpen={true} size="lg" centered toggle={toggle}>
      <NewPlansContainer onClose={toggle} />
    </Modal>
  );
};

export default withRouter(NewPlansView);
